import {Link} from 'react-router';
import {useTranslation} from 'react-i18next';
import type {RushScoreTableEntry} from '@types';
import {DashboardTableDate} from '@components/DashboardTableContent';
import {LeaderboardTable} from '@components/leaderboards/LeaderboardView';

type RushScoreTableProps = {
    data: RushScoreTableEntry[];
    sort: string;
    setSort: (value: string) => void;
    isLoading?: boolean;
    isError?: boolean;
    onRetry?: () => void;
};
export const RushScoreTable = ({
    data,
    sort,
    setSort,
    isLoading = false,
    isError,
    onRetry,
}: RushScoreTableProps) => {
    const {t} = useTranslation();
    return (
        <LeaderboardTable
            columns={[
                {
                    key: 'score',
                    label: t('table_header.general.score'),
                    sortable: true,
                },
                {key: 'type', label: t('rush.rush_type'), align: 'left'},
                {
                    key: 'date',
                    label: t('table_header.general.date'),
                    sortable: true,
                },
            ]}
            primaryColumn="score"
            sortBy={sort}
            onSort={setSort}
            showPositions={sort !== 'date'}
            isLoading={isLoading}
            isError={isError}
            onRetry={onRetry}
            rows={data.map((record, index) => ({
                key: record.id ?? `${record.user?.id}-${index}`,
                user: record.user,
                position: index + 1,
                values: {
                    score: record.id ? (
                        <Link to={`/rushes/${record.id}/result`}>
                            {record.score}
                        </Link>
                    ) : (
                        record.score
                    ),
                    type: t(record.type),
                    date: <DashboardTableDate value={record.date} />,
                },
            }))}
        />
    );
};
